import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "text-h6 text-grey-8 q-mb-sm" };
const _hoisted_2 = { class: "text-body2 text-grey-6 q-pb-md" };
const _hoisted_3 = { class: "row items-center justify-between" };
const _hoisted_4 = { class: "text-h4 text-weight-medium" };
const _hoisted_5 = { class: "text-subtitle1 text-weight-medium q-mb-sm" };
const _hoisted_6 = { class: "form-description text-grey-7" };
const _hoisted_7 = { class: "form-section no-border" };
const _hoisted_8 = { class: "q-my-md" };
const _hoisted_9 = { class: "upload-container relative-position column items-center justify-center q-pa-lg" };
const _hoisted_10 = { class: "icon-circle q-mb-sm flex flex-center" };
const _hoisted_11 = { class: "text-body2 text-grey-9 q-mb-xs" };
const _hoisted_12 = { class: "text-caption text-grey-6" };
const _hoisted_13 = {
    key: 0,
    class: "q-mt-md row items-center bg-white q-pa-sm rounded-borders shadow-1",
    style: { "z-index": "11", "position": "relative" }
};
const _hoisted_14 = { class: "text-caption text-weight-medium" };
const _hoisted_15 = { class: "form-section" };
const _hoisted_16 = { class: "text-subtitle1 text-weight-medium q-mb-sm" };
const _hoisted_17 = { class: "column q-gutter-y-sm" };
const _hoisted_18 = {
    key: 1,
    class: "text-body2 text-grey-7 q-ml-sm"
};
const _hoisted_19 = { class: "q-ml-md q-mt-xs" };
const _hoisted_20 = { class: "form-section" };
const _hoisted_21 = { class: "text-subtitle1 text-weight-medium q-mb-sm" };
const _hoisted_22 = { class: "field-description text-grey-7" };
const _hoisted_23 = { class: "field-example q-mb-sm text-grey-6" };
const _hoisted_24 = { class: "form-section" };
const _hoisted_25 = { class: "text-subtitle1 text-weight-medium q-mb-sm" };
const _hoisted_26 = { class: "field-example q-mb-sm text-grey-6" };
const _hoisted_27 = { class: "form-section" };
const _hoisted_28 = { class: "text-subtitle1 text-weight-medium q-mb-sm" };
const _hoisted_29 = { class: "field-example q-mb-sm text-grey-6" };
const _hoisted_30 = { class: "form-section" };
const _hoisted_31 = { class: "text-subtitle1 text-weight-medium q-mb-sm" };
const _hoisted_32 = { class: "field-description text-grey-7" };
const _hoisted_33 = { class: "field-example q-mb-sm text-grey-6" };
const _hoisted_34 = { class: "form-section" };
const _hoisted_35 = { class: "text-subtitle1 text-weight-medium q-mb-sm" };
const _hoisted_36 = { class: "field-description text-grey-7" };
const _hoisted_37 = { class: "column" };
const _hoisted_38 = { class: "form-section" };
const _hoisted_39 = { class: "text-subtitle1 text-weight-medium q-mb-sm" };
const _hoisted_40 = { class: "column q-gutter-md" };
const _hoisted_41 = { class: "q-ml-lg text-grey-7 text-body2" };
const _hoisted_42 = { class: "q-ml-lg text-grey-7 text-body2" };
const _hoisted_43 = { class: "form-section" };
const _hoisted_44 = { class: "text-subtitle1 text-weight-medium q-mb-sm" };
const _hoisted_45 = { class: "column" };
const _hoisted_46 = { class: "form-section" };
const _hoisted_47 = { class: "text-subtitle1 text-weight-medium q-mb-sm" };
const _hoisted_48 = { class: "field-description text-grey-7" };
const _hoisted_49 = { class: "field-example q-mb-sm text-grey-6" };
const _hoisted_50 = { class: "form-section no-border" };
const _hoisted_51 = { class: "text-subtitle1 text-weight-medium q-mb-sm" };
const _hoisted_52 = { class: "field-description text-grey-7" };
const _hoisted_53 = { class: "column" };
const _hoisted_54 = { class: "row q-gutter-md q-mt-lg q-mb-md" };
import { ref, reactive, computed, onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import BreadcrumbsManager from '@mixins/BreadcrumbsManager.vue';
import { useFacilitiesStore } from '@stores/facilities';
import RemoteSelect from '@components/RemoteSelect.vue';
import DateTimePicker from '@components/DateTimePicker.vue';
import DatePicker from '@components/DatePicker.vue';
import { notifyError } from '@boot/popups.js';
import SuccessMessage from '@components/SuccessMessage.vue';
import { useSettingsStore } from '@stores/settings';
import { useAuthStore } from '@stores/auth';
import { useAssetsStore } from '@stores/assets';
import { axios } from '@boot/axios.js';
const MAX_FILE_SIZE_MB = 10 * 1024 * 1024; // 10MB
export default /*@__PURE__*/ _defineComponent({
    __name: 'Planning',
    props: {
        facilityId: {}
    },
    setup(__props) {
        const { t } = useI18n();
        const settingsStore = useSettingsStore();
        const authStore = useAuthStore();
        const assetsStore = useAssetsStore();
        const FILTER_ASSETS_BY = {
            optimizer_enabled: true
        };
        // facility prop from route params
        const props = __props;
        // Breadcrumb type used by the shared store / BreadcrumbsManager
        const userRole = ref(authStore.getUserRole);
        const isUserPlanner = userRole.value === 'planner';
        // Fetch facility - computed to react to store changes
        const facilitiesStore = useFacilitiesStore();
        const facility = computed(() => facilitiesStore.getFacility(props.facilityId));
        const facilityName = computed(() => facility.value?.name || '');
        // Set breadcrumbs
        const updateBreadcrumbs = () => {
            const breadcrumbs = [
                {
                    label: t('Facilities'),
                    route: { name: 'facility_list' }
                }
            ];
            if (settingsStore.isLiveOEEModuleEnabled && !isUserPlanner) {
                breadcrumbs.push({
                    label: facilityName.value,
                    route: {
                        name: 'facility_dashboard',
                        params: { facilityId: facility.value?.id || props.facilityId }
                    }
                });
            }
            breadcrumbs.push({ label: t('Planning') });
            BreadcrumbsManager.methods.setBreadcrumbs(breadcrumbs);
        };
        onMounted(() => {
            updateBreadcrumbs();
        });
        // Reactively update breadcrumbs when settings load
        watch(() => settingsStore.isLiveOEEModuleEnabled, () => updateBreadcrumbs());
        // Type definitions for form
        const isSubmitting = ref(false);
        const showSuccess = ref(false);
        const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        // Define a type for the asset option
        const selectedAsset = ref(undefined);
        const dateTimeToStart = ref('');
        const formData = reactive({
            facility: '',
            productionLine: '',
            productionOrdersFile: null,
            dateToStart: '',
            timeToStart: '',
            lastProductCode: '',
            productWeight: null,
            historicalDays: null,
            allowSpicyMidWeek: true,
            useDefaultChangeoverTimes: true,
            includeInventoryReport: true,
            compareWithCurrentPlan: false,
            inventoryCheckDate: '',
            selectAllAssets: false
        });
        /**
         * Handles changes to the dateTimeToStart picker and updates formData.
         * Extracts date and time components from the picker's value.
         * Backend expects naive date (YYYY-MM-DD) and time (HH:MM:SS) strings separately.
         * @param newValue - The new ISO date string from the DateTimePicker
         */
        const handleDateTimeChange = (newValue) => {
            dateTimeToStart.value = newValue;
            if (newValue) {
                const date = new Date(newValue);
                // Extract local date components
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                formData.dateToStart = `${year}-${month}-${day}`;
                // Extract local time components (consistent with date extraction)
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                formData.timeToStart = `${hours}:${minutes}:${seconds}`;
            }
            else {
                formData.dateToStart = '';
                formData.timeToStart = '';
            }
        };
        /**
         * Check if the current facility has at least one optimized asset.
         */
        const hasOptimizerEnabledAssets = computed(() => {
            return assetsStore.hasOptimizerEnabledAssets(props.facilityId);
        });
        /**
         * Resets the form to its initial state.
         */
        const resetForm = () => {
            formData.facility = '';
            formData.productionLine = '';
            formData.productionOrdersFile = null;
            formData.dateToStart = '';
            formData.timeToStart = '';
            formData.lastProductCode = '';
            formData.productWeight = null;
            formData.historicalDays = null;
            formData.allowSpicyMidWeek = true;
            formData.useDefaultChangeoverTimes = true;
            formData.includeInventoryReport = true;
            formData.compareWithCurrentPlan = false;
            formData.inventoryCheckDate = '';
            formData.selectAllAssets = false;
            selectedAsset.value = undefined;
            dateTimeToStart.value = '';
        };
        /**
         * Gets the error message for missing asset selection.
         */
        const getAssetSelectionErrorMessage = () => {
            return t('Please select a production line or choose to select all lines.');
        };
        /**
         * Handles form submission for planning.
         */
        const handleSubmit = async () => {
            isSubmitting.value = true;
            formData.facility = props.facilityId;
            formData.productionLine = selectedAsset.value?.value || '';
            // Validate file upload
            if (!formData.productionOrdersFile) {
                notifyError(t('Please upload a production orders file before submitting.'));
                isSubmitting.value = false;
                return;
            }
            // Validate asset selection
            if (!(formData.selectAllAssets || !!formData.productionLine)) {
                notifyError(getAssetSelectionErrorMessage());
                isSubmitting.value = false;
                return;
            }
            // Prepare FormData for multipart/form-data, only include non-null/undefined fields
            const multipart = new FormData();
            if (formData.facility)
                multipart.append('facility', formData.facility);
            if (formData.productionLine)
                multipart.append('asset', formData.productionLine);
            multipart.append('select_all_assets', String(formData.selectAllAssets));
            if (formData.productionOrdersFile)
                multipart.append('production_orders_file', formData.productionOrdersFile);
            if (formData.dateToStart)
                multipart.append('date_to_start', formData.dateToStart);
            if (formData.timeToStart)
                multipart.append('time_to_start', formData.timeToStart);
            if (formData.lastProductCode)
                multipart.append('last_product_code', formData.lastProductCode);
            if (formData.productWeight !== null && formData.productWeight !== undefined)
                multipart.append('product_weight', String(formData.productWeight));
            if (formData.historicalDays !== null &&
                formData.historicalDays !== undefined)
                multipart.append('historical_days', String(formData.historicalDays));
            multipart.append('allow_spicy_mid_week', String(formData.allowSpicyMidWeek));
            multipart.append('use_default_changeover_times', String(formData.useDefaultChangeoverTimes));
            multipart.append('include_inventory_report', String(formData.includeInventoryReport));
            multipart.append('compare_with_current_plan', String(formData.compareWithCurrentPlan));
            if (formData.inventoryCheckDate)
                multipart.append('inventory_check_date', formData.inventoryCheckDate);
            try {
                await axios.post('/planning/optimize/', multipart, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                showSuccess.value = true;
            }
            catch (error) {
                handleAPIErrors(error);
            }
            finally {
                isSubmitting.value = false;
            }
        };
        /**
         * Handles file rejection events from the file upload component.
         * @param rejectedEntries
         */
        const onFileRejected = (rejectedEntries) => {
            const entry = rejectedEntries[0];
            if (entry.failedPropValidation === 'max-file-size') {
                notifyError(t('File size exceeds 10MB limit'));
            }
            else if (entry.failedPropValidation === 'accept') {
                notifyError(t('Invalid file type. Please upload an Excel file (.xls or .xlsx)'));
            }
            else {
                notifyError(t('File upload failed'));
            }
        };
        /**
         * Handles API errors and displays appropriate notifications.
         * @param error - The error object from the API call
         */
        const handleAPIErrors = (error) => {
            let errorData;
            if (error &&
                typeof error === 'object' &&
                'response' in error &&
                error.response &&
                typeof error.response === 'object' &&
                'data' in error.response) {
                const response = error.response;
                errorData = response.data;
            }
            // Check for field-specific errors with nested error_code (e.g., asset.error_code)
            if (errorData?.asset?.error_code) {
                const assetErrorCode = Array.isArray(errorData.asset.error_code)
                    ? errorData.asset.error_code[0]
                    : errorData.asset.error_code;
                if (assetErrorCode === 'optimizer_not_enabled_for_asset') {
                    notifyError(t('The selected production line does not have planning enabled.'));
                    return;
                }
            }
            // Normalize error_code - handle both string and array formats
            const errorCode = Array.isArray(errorData?.error_code)
                ? errorData.error_code[0]
                : errorData?.error_code;
            // Handle field-specific validation errors
            if (errorData?.production_orders_file) {
                notifyError(t('Invalid file upload. Please ensure you are uploading a valid Excel file.'));
                return;
            }
            // Handle specific error codes
            switch (errorCode) {
                case 'missing_asset_or_select_all':
                    notifyError(getAssetSelectionErrorMessage());
                    break;
                case 'mutually_exclusive_asset_selection':
                    notifyError(t('Cannot specify both a production line and select all lines. Please choose one option only.'));
                    break;
                case 'excel_validation_error': {
                    notifyError(t('Excel file validation failed. Please check your file format and ensure it contains the required columns.'));
                    break;
                }
                case 'optimizer_service_bad_gateway':
                    notifyError(t('Unable to connect to the optimizer service. Please try again later.'));
                    break;
                case 'optimizer_service_not_configured':
                    notifyError(t('Optimizer service is not configured. Please try again later.'));
                    break;
                case 'optimizer_not_enabled_for_asset':
                    notifyError(t('The selected production line does not have planning enabled.'));
                    break;
                default:
                    // Generic fallback error
                    notifyError(t('An error occurred while submitting the form. Please try again.'), error);
            }
        };
        return (_ctx, _cache) => {
            const _component_q_card_section = _resolveComponent("q-card-section");
            const _component_q_card = _resolveComponent("q-card");
            const _component_q_icon = _resolveComponent("q-icon");
            const _component_q_btn = _resolveComponent("q-btn");
            const _component_q_file = _resolveComponent("q-file");
            const _component_q_checkbox = _resolveComponent("q-checkbox");
            const _component_q_badge = _resolveComponent("q-badge");
            const _component_q_input = _resolveComponent("q-input");
            const _component_q_radio = _resolveComponent("q-radio");
            const _component_q_spinner_facebook = _resolveComponent("q-spinner-facebook");
            return (_openBlock(), _createElementBlock("div", null, [
                (showSuccess.value)
                    ? (_openBlock(), _createBlock(_component_q_card, {
                        key: 0,
                        class: "q-mt-md form-container"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_q_card_section, { class: "q-py-xl" }, {
                                default: _withCtx(() => [
                                    _createVNode(SuccessMessage, {
                                        title: _unref(t)('Submitted'),
                                        message: _unref(t)('Optimization request accepted and it is currently being processed. The results will be sent to your email address in less than 10 minutes.'),
                                        "button-label": _unref(t)('Continue'),
                                        onContinue: _cache[0] || (_cache[0] =
                                            () => {
                                                showSuccess.value = false;
                                                resetForm();
                                            })
                                    }, null, 8, ["title", "message", "button-label"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                (!showSuccess.value && !hasOptimizerEnabledAssets.value)
                    ? (_openBlock(), _createBlock(_component_q_card, {
                        key: 1,
                        class: "q-mt-md form-container"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_q_card_section, { class: "text-center q-py-xl" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_q_icon, {
                                        name: "info",
                                        size: "64px",
                                        color: "grey-5",
                                        class: "q-mb-md"
                                    }),
                                    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('No Production Lines Available')), 1),
                                    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('Planning is not enabled for any production lines in this facility. To access this feature, at least one production line in the facility must have this setting enabled.')), 1),
                                    _createVNode(_component_q_btn, {
                                        label: _unref(t)('Back'),
                                        color: "accent",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$router.back()))
                                    }, null, 8, ["label"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }))
                    : (!showSuccess.value)
                        ? (_openBlock(), _createBlock(_component_q_card, {
                            key: 2,
                            class: "q-mt-md form-container"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_q_card_section, { class: "q-py-md" }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("form", {
                                            onSubmit: _withModifiers(handleSubmit, ["prevent"])
                                        }, [
                                            _createElementVNode("div", _hoisted_3, [
                                                _createElementVNode("div", null, [
                                                    _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('Planning')), 1),
                                                    _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('Production Scheduling Input Form')), 1)
                                                ]),
                                                _createVNode(_component_q_btn, {
                                                    label: _unref(t)('Download schedule template'),
                                                    class: "bg-white q-my-md",
                                                    "text-color": "accent",
                                                    outline: "",
                                                    icon: "fas fa-download",
                                                    href: `/templates/production_scheduling_template.xlsx`,
                                                    target: "_blank"
                                                }, null, 8, ["label"])
                                            ]),
                                            _createElementVNode("div", _hoisted_6, [
                                                _createElementVNode("p", null, _toDisplayString(_unref(t)("This form collects inputs for scheduling optimization: provide facility, line, and production order quantities. The system analyzes historical performance, changeovers, and optional inventory feasibility. Enter a schedule start time and historical data window to drive run rate and changeover calculations, and refine with advanced constraints (spicy mid-week, starting size, defaults). After submission, the process runs asynchronously and you'll receive an email within 10 minutes — success emails include the schedule file, failure emails include error details so you can adjust and resubmit. Use accurate product codes and dates to avoid validation errors.")), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_7, [
                                                _createElementVNode("div", _hoisted_8, [
                                                    _createElementVNode("div", _hoisted_9, [
                                                        _createVNode(_component_q_file, {
                                                            modelValue: formData.productionOrdersFile,
                                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((formData.productionOrdersFile) = $event)),
                                                            class: "absolute-full cursor-pointer",
                                                            style: { "opacity": "0", "z-index": "10" },
                                                            accept: ".xlsx, .xls",
                                                            "max-file-size": MAX_FILE_SIZE_MB,
                                                            onRejected: onFileRejected,
                                                            label: _unref(t)('Upload file')
                                                        }, null, 8, ["modelValue", "label"]),
                                                        _createElementVNode("div", _hoisted_10, [
                                                            _createVNode(_component_q_icon, {
                                                                name: "upload",
                                                                size: "24px",
                                                                color: "accent"
                                                            })
                                                        ]),
                                                        _createElementVNode("div", _hoisted_11, [
                                                            _createTextVNode(_toDisplayString(_unref(t)('Upload production orders and current usage file')) + " ", 1),
                                                            _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-negative text-weight-medium" }, " * ", -1))
                                                        ]),
                                                        _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('Supported Format: Excel (.xls, .xlsx) (10MB limit)')), 1),
                                                        (formData.productionOrdersFile)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                                                _createVNode(_component_q_icon, {
                                                                    name: "description",
                                                                    color: "accent",
                                                                    class: "q-mr-sm"
                                                                }),
                                                                _createElementVNode("span", _hoisted_14, _toDisplayString(formData.productionOrdersFile.name), 1),
                                                                _createVNode(_component_q_btn, {
                                                                    flat: "",
                                                                    round: "",
                                                                    dense: "",
                                                                    icon: "close",
                                                                    size: "sm",
                                                                    color: "grey-7",
                                                                    class: "q-ml-sm",
                                                                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (formData.productionOrdersFile = null), ["stop"]))
                                                                })
                                                            ]))
                                                            : _createCommentVNode("", true)
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_15, [
                                                _createElementVNode("div", _hoisted_16, [
                                                    _createTextVNode(_toDisplayString(_unref(t)('Production line')) + " ", 1),
                                                    _cache[20] || (_cache[20] = _createElementVNode("span", { class: "text-negative text-weight-medium" }, " * ", -1))
                                                ]),
                                                _createElementVNode("div", _hoisted_17, [
                                                    _createVNode(_component_q_checkbox, {
                                                        modelValue: formData.selectAllAssets,
                                                        "onUpdate:modelValue": [
                                                            _cache[4] || (_cache[4] = ($event) => ((formData.selectAllAssets) = $event)),
                                                            _cache[5] || (_cache[5] =
                                                                val => {
                                                                    if (val)
                                                                        selectedAsset.value = undefined;
                                                                })
                                                        ],
                                                        color: "accent",
                                                        label: _unref(t)('Select all production lines in this facility')
                                                    }, null, 8, ["modelValue", "label"]),
                                                    (!formData.selectAllAssets)
                                                        ? (_openBlock(), _createBlock(RemoteSelect, {
                                                            key: 0,
                                                            id: "asset-select",
                                                            "model-value": selectedAsset.value,
                                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => (selectedAsset.value = $event)),
                                                            label: _unref(t)('Production line'),
                                                            baseURL: 'assets/',
                                                            urlParams: {
                                                                facility: __props.facilityId,
                                                                ordering: 'name'
                                                            },
                                                            outlined: "",
                                                            searchable: "",
                                                            clearable: true,
                                                            readonly: true,
                                                            disable: formData.selectAllAssets,
                                                            multiple: false,
                                                            "filter-by": FILTER_ASSETS_BY,
                                                            "no-options-after-filter": _unref(t)('This facility has no production lines with planning enabled.')
                                                        }, null, 8, ["model-value", "label", "urlParams", "disable", "no-options-after-filter"]))
                                                        : _createCommentVNode("", true),
                                                    (formData.selectAllAssets)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                            _createTextVNode(_toDisplayString(_unref(t)('The following production lines will be included:')) + " ", 1),
                                                            _createElementVNode("ul", _hoisted_19, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(assetsStore).getOptimizerEnabledAssets(__props.facilityId), (asset) => {
                                                                    return (_openBlock(), _createElementBlock("li", {
                                                                        key: asset.id
                                                                    }, _toDisplayString(asset.name), 1));
                                                                }), 128))
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_20, [
                                                _createElementVNode("div", _hoisted_21, [
                                                    _createTextVNode(_toDisplayString(_unref(t)('Date and time to start the schedule')) + " ", 1),
                                                    _createVNode(_component_q_badge, {
                                                        rounded: "",
                                                        color: "lighter-grey",
                                                        "text-color": "secondary"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_unref(t)('Optional')), 1)
                                                        ]),
                                                        _: 1
                                                    }),
                                                    _createElementVNode("p", _hoisted_22, _toDisplayString(_unref(t)("If left blank, today's date and time will be assumed.")), 1),
                                                    _createElementVNode("p", _hoisted_23, _toDisplayString(_unref(t)('e.g.: 2025/10/15 08:30:00')), 1)
                                                ]),
                                                _createVNode(DateTimePicker, {
                                                    id: "start-period-input",
                                                    "model-value": dateTimeToStart.value,
                                                    "onUpdate:modelValue": handleDateTimeChange,
                                                    label: _unref(t)('Start') + ' (' + _unref(localTimeZone) + ')',
                                                    "allow-empty": true,
                                                    "default-to-now": true
                                                }, null, 8, ["model-value", "label"])
                                            ]),
                                            _createElementVNode("div", _hoisted_24, [
                                                _createElementVNode("div", _hoisted_25, [
                                                    _createTextVNode(_toDisplayString(_unref(t)('Last product code that immediately precedes the current sequencing task? (If known)')) + " ", 1),
                                                    _createVNode(_component_q_badge, {
                                                        rounded: "",
                                                        color: "lighter-grey",
                                                        "text-color": "secondary"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_unref(t)('Optional')), 1)
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _createElementVNode("p", _hoisted_26, _toDisplayString(_unref(t)('e.g.: 1234567')), 1),
                                                _createVNode(_component_q_input, {
                                                    outlined: "",
                                                    color: "accent",
                                                    modelValue: formData.lastProductCode,
                                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((formData.lastProductCode) = $event)),
                                                    placeholder: _unref(t)('Enter your answer')
                                                }, null, 8, ["modelValue", "placeholder"])
                                            ]),
                                            _createElementVNode("div", _hoisted_27, [
                                                _createElementVNode("div", _hoisted_28, [
                                                    _createTextVNode(_toDisplayString(_unref(t)('Size (weight) of the product to start the scheduling with, in grams (if known)')) + " ", 1),
                                                    _createVNode(_component_q_badge, {
                                                        rounded: "",
                                                        color: "lighter-grey",
                                                        "text-color": "secondary"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_unref(t)('Optional')), 1)
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _createElementVNode("p", _hoisted_29, _toDisplayString(_unref(t)('e.g.: 320')), 1),
                                                _createVNode(_component_q_input, {
                                                    outlined: "",
                                                    color: "accent",
                                                    modelValue: formData.productWeight,
                                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((formData.productWeight) = $event)),
                                                    modelModifiers: { number: true },
                                                    type: "number",
                                                    min: "0",
                                                    step: "1",
                                                    placeholder: _unref(t)('Enter your answer')
                                                }, null, 8, ["modelValue", "placeholder"])
                                            ]),
                                            _createElementVNode("div", _hoisted_30, [
                                                _createElementVNode("div", _hoisted_31, [
                                                    _createTextVNode(_toDisplayString(_unref(t)('Number of historical days to analyze to generate the schedule? Default is 120 days.')) + " ", 1),
                                                    _createVNode(_component_q_badge, {
                                                        rounded: "",
                                                        color: "lighter-grey",
                                                        "text-color": "secondary"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_unref(t)('Optional')), 1)
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _createElementVNode("p", _hoisted_32, _toDisplayString(_unref(t)('It is recommended to use at least 60 days of historical data to capture typical changeovers and production run rates. Using too few days may result in missing product records, causing the system to assume default run rates, which can reduce schedule accuracy. Max is 240 days.')), 1),
                                                _createElementVNode("p", _hoisted_33, _toDisplayString(_unref(t)('e.g.: 60')), 1),
                                                _createVNode(_component_q_input, {
                                                    outlined: "",
                                                    color: "accent",
                                                    modelValue: formData.historicalDays,
                                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((formData.historicalDays) = $event)),
                                                    modelModifiers: { number: true },
                                                    type: "number",
                                                    min: "1",
                                                    max: "240",
                                                    placeholder: _unref(t)('Enter your answer')
                                                }, null, 8, ["modelValue", "placeholder"])
                                            ]),
                                            _createElementVNode("div", _hoisted_34, [
                                                _createElementVNode("div", _hoisted_35, [
                                                    _createTextVNode(_toDisplayString(_unref(t)('Allowing spicy/flavored products to be scheduled mid-week? Or in other words, would you like to allows transitions from spicy to non-spicy products?')) + " ", 1),
                                                    _createVNode(_component_q_badge, {
                                                        rounded: "",
                                                        color: "lighter-grey",
                                                        "text-color": "secondary"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_unref(t)('Optional')), 1)
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _createElementVNode("p", _hoisted_36, _toDisplayString(_unref(t)('Default is Yes. If No, spicy SKUs will be scheduled at the end of the period.')), 1),
                                                _createElementVNode("div", _hoisted_37, [
                                                    _createVNode(_component_q_radio, {
                                                        modelValue: formData.allowSpicyMidWeek,
                                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((formData.allowSpicyMidWeek) = $event)),
                                                        color: "accent",
                                                        val: true,
                                                        label: _unref(t)('Yes')
                                                    }, null, 8, ["modelValue", "label"]),
                                                    _createVNode(_component_q_radio, {
                                                        modelValue: formData.allowSpicyMidWeek,
                                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((formData.allowSpicyMidWeek) = $event)),
                                                        color: "accent",
                                                        val: false,
                                                        label: _unref(t)('No')
                                                    }, null, 8, ["modelValue", "label"])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_38, [
                                                _createElementVNode("div", _hoisted_39, [
                                                    _createTextVNode(_toDisplayString(_unref(t)('Use default changeover times?')) + " ", 1),
                                                    _createVNode(_component_q_badge, {
                                                        rounded: "",
                                                        color: "lighter-grey",
                                                        "text-color": "secondary"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_unref(t)('Optional')), 1)
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _createElementVNode("div", _hoisted_40, [
                                                    _createElementVNode("div", null, [
                                                        _createVNode(_component_q_radio, {
                                                            modelValue: formData.useDefaultChangeoverTimes,
                                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((formData.useDefaultChangeoverTimes) = $event)),
                                                            color: "accent",
                                                            val: true,
                                                            label: _unref(t)('Yes')
                                                        }, null, 8, ["modelValue", "label"]),
                                                        _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(t)('The baseline changeover durations will be applied.')), 1)
                                                    ]),
                                                    _createElementVNode("div", null, [
                                                        _createVNode(_component_q_radio, {
                                                            modelValue: formData.useDefaultChangeoverTimes,
                                                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((formData.useDefaultChangeoverTimes) = $event)),
                                                            color: "accent",
                                                            val: false,
                                                            label: _unref(t)('No')
                                                        }, null, 8, ["modelValue", "label"]),
                                                        _createElementVNode("div", _hoisted_42, _toDisplayString(_unref(t)('Historical data will be analyzed to extract changeover information based on the selected history period. In this case, the resulting sequence may not exactly match the baseline durations; however, safeguards are in place to prevent generating schedules with unrealistic changeover times. When such cases occur, the system will automatically revert to the default values.')), 1)
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_43, [
                                                _createElementVNode("div", _hoisted_44, [
                                                    _createTextVNode(_toDisplayString(_unref(t)('Whether to include inventory report (for film, box and bulk) in the output file? Missing inventories will be highlighted.')) + " ", 1),
                                                    _createVNode(_component_q_badge, {
                                                        rounded: "",
                                                        color: "lighter-grey",
                                                        "text-color": "secondary"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_unref(t)('Optional')), 1)
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _createElementVNode("div", _hoisted_45, [
                                                    _createVNode(_component_q_radio, {
                                                        modelValue: formData.includeInventoryReport,
                                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((formData.includeInventoryReport) = $event)),
                                                        color: "accent",
                                                        val: true,
                                                        label: _unref(t)('Yes')
                                                    }, null, 8, ["modelValue", "label"]),
                                                    _createVNode(_component_q_radio, {
                                                        modelValue: formData.includeInventoryReport,
                                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((formData.includeInventoryReport) = $event)),
                                                        color: "accent",
                                                        val: false,
                                                        label: _unref(t)('No')
                                                    }, null, 8, ["modelValue", "label"])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_46, [
                                                _createElementVNode("div", _hoisted_47, [
                                                    _createTextVNode(_toDisplayString(_unref(t)('Date of inventory check?')) + " ", 1),
                                                    _createVNode(_component_q_badge, {
                                                        rounded: "",
                                                        color: "lighter-grey",
                                                        "text-color": "secondary"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_unref(t)('Optional')), 1)
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _createElementVNode("p", _hoisted_48, _toDisplayString(_unref(t)("If left blank, today's date will be assumed. Note that inventories are checked as of 6:00 AM EST on the chosen day.")), 1),
                                                _createElementVNode("p", _hoisted_49, _toDisplayString(_unref(t)('e.g.: 2025/10/14')), 1),
                                                _createVNode(DatePicker, {
                                                    id: "inventory-check-date-input",
                                                    modelValue: formData.inventoryCheckDate,
                                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((formData.inventoryCheckDate) = $event)),
                                                    label: _unref(t)('Inventory check date'),
                                                    "allow-empty": true,
                                                    "enable-validation-rules": true,
                                                    "default-to-now": true
                                                }, null, 8, ["modelValue", "label"])
                                            ]),
                                            _createElementVNode("div", _hoisted_50, [
                                                _createElementVNode("div", _hoisted_51, [
                                                    _createTextVNode(_toDisplayString(_unref(t)('Comparison with the current facility plan?')) + " ", 1),
                                                    _createVNode(_component_q_badge, {
                                                        rounded: "",
                                                        color: "lighter-grey",
                                                        "text-color": "secondary"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_unref(t)('Optional')), 1)
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _createElementVNode("p", _hoisted_52, _toDisplayString(_unref(t)('If you like to compare your own sequencing with the algorithm sequence and compare expected changeover times, please upload your product sequence (only the SKUs) in the 3rd tab of the uploaded file. The tab name should be "current_plan".')), 1),
                                                _createElementVNode("div", _hoisted_53, [
                                                    _createVNode(_component_q_radio, {
                                                        modelValue: formData.compareWithCurrentPlan,
                                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((formData.compareWithCurrentPlan) = $event)),
                                                        color: "accent",
                                                        val: true,
                                                        label: _unref(t)('Yes')
                                                    }, null, 8, ["modelValue", "label"]),
                                                    _createVNode(_component_q_radio, {
                                                        modelValue: formData.compareWithCurrentPlan,
                                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((formData.compareWithCurrentPlan) = $event)),
                                                        color: "accent",
                                                        val: false,
                                                        label: _unref(t)('No')
                                                    }, null, 8, ["modelValue", "label"])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_54, [
                                                _createVNode(_component_q_btn, {
                                                    type: "submit",
                                                    unelevated: "",
                                                    color: "accent",
                                                    loading: isSubmitting.value,
                                                    label: _unref(t)('Submit'),
                                                    class: "col-grow"
                                                }, {
                                                    loading: _withCtx(() => [
                                                        _createVNode(_component_q_spinner_facebook)
                                                    ]),
                                                    _: 1
                                                }, 8, ["loading", "label"]),
                                                _createVNode(_component_q_btn, {
                                                    type: "button",
                                                    unelevated: "",
                                                    color: "grey-7",
                                                    onClick: resetForm,
                                                    disable: isSubmitting.value,
                                                    label: _unref(t)('Clear')
                                                }, null, 8, ["disable", "label"])
                                            ])
                                        ], 32)
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true)
            ]));
        };
    }
});
